import { render, staticRenderFns } from "./ArticlesPreviewPrint.vue?vue&type=template&id=ca76e6b6"
import script from "./ArticlesPreviewPrint.vue?vue&type=script&lang=js"
export * from "./ArticlesPreviewPrint.vue?vue&type=script&lang=js"
import style0 from "./ArticlesPreviewPrint.vue?vue&type=style&index=0&id=ca76e6b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports